import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  HistoryEntryIcon,
  HistoryEntryMainText,
  HistoryEntrySubText,
  HistoryItemProps,
  UserInfoDisplay,
} from "./common";
import { getStatusIcon, VerificationStatus } from "../../../utils/getStatus";
import { CollapsibleMessage } from "./CollapsibleMessage";

export const HistoryItemStatusChanged = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  const { details } = item;
  const statusChange = details?.statusChange;

  const getIcon = () => {
    if (statusChange?.toStatus === VerificationStatus.INFORMATION_REQUESTED) {
      const statusConfig = statusesConfig?.object[statusChange.toStatus];

      return getStatusIcon(VerificationStatus.INFORMATION_REQUESTED, {
        fill: statusConfig?.color,
        color: statusConfig?.color,
        sx: {
          height: 20,
          width: 20,
        },
      });
    }

    if (statusChange?.toStatus && statusesConfig) {
      const statusConfig = (statusesConfig.object as any)[
        statusChange.toStatus
      ];
      return getStatusIcon(statusChange?.toStatus as any, {
        fill: statusConfig?.color,
        color: statusConfig?.color,
      });
    }
    return <InfoOutlinedIcon sx={{ height: 20, color: "#2196F3" }} />;
  };

  const getDisplayName = (status: string) => {
    if (status && statusesConfig) {
      const statusConfig = (statusesConfig.object as any)[status];
      return statusConfig?.displayName;
    }
    return "";
  };

  const getTitle = () => {
    return getDisplayName(statusChange?.toStatus || "") || "Status Changed";
  };

  return (
    <>
      <HistoryEntryIcon>{getIcon()}</HistoryEntryIcon>

      <HistoryEntryMainText>{getTitle()}</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />

      {statusChange?.reason && (
        <HistoryEntrySubText label="Reason">
          {statusChange.reason}
        </HistoryEntrySubText>
      )}
      {statusChange?.message && (
        <CollapsibleMessage message={statusChange.message} />
      )}
    </>
  );
};
